import PropTypes from '@root/vendor/prop-types';
import React, { Component } from '@root/vendor/react';
import Toggle from '@root/core/src/components/toggle';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';
export default class ProfileReviewAntiTheftEquipment extends Component {
  static propTypes = {
    antiTheftEquipment: PropTypes.bool.isRequired,
    circleSelectedStyles: PropTypes.object,
    onClick: PropTypes.func.isRequired,
    toggleSelectedStyles: PropTypes.object,
  }

  render() {
    return (
      <div css={styles.wrapper}>
        <div
          css={styles.leftBox}
        >
          <h3 css={styles.heading}>
            Vehicle has anti-theft equipment
          </h3>
          <p css={styles.content}>
            We’re looking for any system or device that is designed to prevent theft and is permanently installed on your vehicle.
          </p>
        </div>
        <div
          css={styles.rightBox}
          onClick={this.props.onClick}
        >
          <Toggle
            circleSelectedStyles={this.props.circleSelectedStyles}
            isSelected={this.props.antiTheftEquipment}
            toggleSelectedStyles={this.props.toggleSelectedStyles}
          />
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  heading: {
    ...Theme.heading3(),
  },
  content: {
    ...Theme.paragraph2(),
  },
  wrapper: {
    marginTop: 30,
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftBox: {
    width: '75%',
  },
  rightBox: {
    width: '25%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
});
